import type { BridgeView } from '@/api/types';
import { tr, useT } from '@/i18n';
import { formatCountdown } from '@/lib/format';
import styles from './MetaLine.module.css';

/** The compact status line of an open bridge: countdown, views and the live indicator. */
export function MetaLine({ view, online, now }: { readonly view: BridgeView; readonly online: boolean; readonly now: number }): React.JSX.Element {
  const t = useT();
  return (
    <div className={styles.metaLine}>
      <span>
        {tr('common.expiresInCountdown', { strong: (children) => <strong data-testid="countdown">{children}</strong> }, { countdown: formatCountdown(view.expiresAt, now) })}
      </span>
      <span className={styles.metaSep} aria-hidden="true" />
      <span>
        {t('common.views')}{' '}
        <strong data-testid="views">
          {view.views}/{view.maxViews}
        </strong>
      </span>
      <span className={styles.metaSep} aria-hidden="true" />
      <span className={[styles.online, online ? '' : styles.offline].join(' ')}>
        <i />
        {online ? t('metaLine.live') : t('metaLine.reconnecting')}
      </span>
    </div>
  );
}
